// extracted by mini-css-extract-plugin
export default {"form":"EditOfferView_form__bcgcE","error":"EditOfferView_error__AjCPJ"};